/**
 * Numeric rank for plan comparison (higher = more features).
 *
 * 2026-09-25 RUN1 FASE2 planRank SSOT (research 2026 vezadigital 2026-03-06
 * "Best SaaS Pricing Page Examples" — single source of truth for plan tiers:
 * https://www.vezadigital.com/post/best-saas-pricing-page-examples): escala
 * ÚNICA free=1 < go=2 < pro=3 < max=4 < maxplus=5, desconocido=0 fail-closed.
 *
 * 2026-10-09 bundle-budget (RUN16 follow-up): esta escala se SEPARÓ de
 * `@/lib/api-utils` en un módulo hoja sin dependencias. Antes vivía allí y
 * tres superficies CLIENTE la importaban desde ese módulo
 * (`Pricing.tsx`, `use-pricing.ts`, `CheckoutContent.tsx`), y
 * `@/lib/billing-plans` —también cliente vía `Pricing.tsx`— delegaba en ella.
 * Como `api-utils` importa `getApiError` de `@/lib/api-i18n` (≈114 KB de
 * mensajes de error de API en 14 locales, solo útiles en servidor), toda esa
 * tabla viajaba en el chunk compartido del first-load de `/` (medido
 * 2026-10-09: chunk `0w97-fj5jlf96.js` = 114 KB). Con la hoja,
 * `api-i18n` vuelve a ser exclusivamente servidor.
 *
 * `api-utils.ts` y `billing-plans.ts` re-exportan/delegan aquí — cero cambios
 * en los consumidores de servidor, y los de cliente importan esta ruta.
 */
export function planRank(plan: string | null | undefined): number {
  if (plan === "maxplus") return 5;
  if (plan === "max") return 4;
  if (plan === "pro") return 3;
  if (plan === "go") return 2;
  if (plan === "free") return 1;
  return 0;
}
